import { css } from "emotion";
import React from "react";
import { isAbsent } from "../../utils";

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    padding: 2rem 3rem;
    background-color: #fff;
    border-radius: 0.5rem;
    margin-bottom: 1rem;
    border: 1px solid #e0e0e0;
    font-size: 1.5rem;
    font-weight: 600;
    color: #041d44;
    text-align: center;
    justify-content: center;
    align-items: center;
    height: 100%;

    & h2 {
      font-size: 18px;
    }

    & dl {
      margin-left: auto;
      display: grid;
      grid-template-rows: auto auto;
      grid-auto-columns: 1fr;
      grid-auto-flow: column;
      font-weight: bold;
      text-align: right;

      & dt,
      & dd {
        padding-right: 3rem;
      }

      & dd {
        font-weight: 400;
      }
    }
  `,
};

const Totals = ({ totals }) => {
  if (isAbsent(totals)) return null;

  return (
    <div className={styles.container}>
      <h2>Totals for this period</h2>
      <dl>
        {totals.map(({ description, value }) => (
          <React.Fragment key={description}>
            <dt id={description}>{description}</dt>
            <dd aria-labelledby={description}>{value}</dd>
          </React.Fragment>
        ))}
      </dl>
    </div>
  );
};

export default Totals;
